// "YES (Consider the start price)": a prebid that doesn't beat the start price
// is accepted but doesn't count. The wording follows the auction type, so a
// reverse-auction bidder isn't told "below", which would sound like a good bid.

// "Not above start price" (forward) / "Not below start price" (reverse)
export const notBeatingStartPriceLabel = (eventType) =>
  eventType === "REVERSE_AUCTION"
    ? "Not below start price"
    : "Not above start price";

// sentence used where the page shows "Your bid is (not) among top 3 bids"
export const notBeatingStartPriceSentence = (eventType) =>
  eventType === "REVERSE_AUCTION"
    ? "Your bid is not below the start price."
    : "Your bid is not above the start price.";
